exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.d2-contentmenu-list .d2-contentmenu-item{padding:8px 20px 8px 15px;margin:0;font-size:14px;color:#606266;cursor:pointer\n}\n.d2-contentmenu-list .d2-contentmenu-item:hover{background:#ecf5ff;color:#66b1ff\n}\n.d2-contentmenu-list .d2-contentmenu-item .d2-contentmenu-item-title{margin-left:10px\n}\n", ""]);

// exports
